import { Component, Input } from "@angular/core";
import { first } from "rxjs/operators";
import { I18nService } from "src/app/i18n/services";
import { HelpTarget, SettingTarget } from "src/app/interfaces/helpTarget";
import { LogClass, Logger } from "src/app/logger";
import { AbstractSettingsService } from "src/app/settings/abstractSettingsService";

@Component({
    selector: "help-link",
    templateUrl: "./help-link.component.html",
    styleUrls: ["./help-link.component.scss"],
    standalone: false
})
@LogClass({ source: "HelpLinkComponent" })
export class HelpLinkComponent {
  private logger: Logger;
  /**
   * The link to open on click
   */
  @Input() public target: HelpTarget;

  /**
   * hint-text
   */
  @Input() public hintText = "help.title";

  constructor(
    private settings: AbstractSettingsService,
    private i18n: I18nService
  ) {}

  public openHelp(): void {
    this.logger.debug("getting help-link for " + this.target);
    this.settings
      .GetSettingLink(
        SettingTarget[SettingTarget.HelpTarget],
        HelpTarget[this.target]
      )
      .pipe(first())
      .subscribe((x) => {
        let lang = this.i18n.getLocale() || "";
        this.logger.debug("checking help-link for language: " + lang);
        let target = x[lang];
        if (!target) {
          lang = lang.split("-", 2)[0];
          this.logger.debug("checking help-link for language: " + lang);
          target = x[lang];
        }
        if (!target) {
          this.logger.debug("using default help-link");
          target = x.default;
        }

        this.logger.debug("opening help-link: " + target);
        window.open(target, "_blank");
      });
  }
}
